<div class="d-flex flex-column h-100 active_report" id="activeReport">
  <!-- Data heading and info -->
  <div class="data_header" id="dataHeading">
    <div class="left_side_section" id="activeReportLeftSideSection">
      <div class="results_info" id="resultsInfo">
        <div class="title" id="activeReportTitle">
          <span *ngIf="userRole=='storeUser'">{{storeName}}</span>
          <span [ngClass]="{'title-text':userRole=='storeUser'}" i18n="@@active-device-report.data-header.active-device-report">Active Device Report</span>
        </div>
        <span *ngIf="userRole=='storeUser'" i18n="@@active-device-report.data-header.text-for-store-user">This report
          details all information about your store and its connected devices.</span>
        <div class="results" *ngIf="userRole!='storeUser'" id="activeResults">
          <div id="storCountDiv">
            <img class="store-location-icon" src="../../../../assets/images/location_pin_icon.svg" alt="" />
            <span class="store-count-text" i18n="@@active-device-report.label.store-count">Store Count</span> : {{totalStoreCount}}
          </div>
          <div id="deviceCount" [ngClass]="{'store-count-lang': isItalian || isPortugese_Brazil || isPortugese_Portugal || isRomanian || isRussian || isSpanish_Mexico || isSpanish || isUkranian}">
            <img class="device-icon" src="../../../../assets/images/laptop_icon_dark.svg" alt="" />
            <span class="device-count-text" i18n="@@active-device-report.data-header.device-count">Device Count</span> : {{totalDeviceCount}}
          </div>
        </div>
      </div>
    </div>
    <div id="noStoreNote">
    <span i18n="@@active-device-report.no-store-txt.no-store-will-be-displayed" *ngIf="isNoStoreExists && !isEnglish" class="no_store_note"><strong>Note:</strong> The store name “No Store” will be displayed if no store is selected during installation.</span>
    <div *ngIf="displayActiveuser?.length > 0 || userRole ==='storeUser'" [ngClass]="{'action-btn-store' : userRole === 'storeUser', 'no-store-action-btn-store': isNoStoreExists && !isEnglish}"  class="action_buttons" id="actionButtons">
      <ng-container
        *ngIf="!isGenerateSelectedClicked && (isSelected.size == 0 || deviceStatusReport === 'generating' || (reportDownloadType === 'multi' && isSelected.size >= 1) || (deviceStatusReport === 'generated' && reportDownloadType === 'full') || !reportDownloadType)">
        <button *ngIf="userRole!='storeUser'" type="button"
          [ngClass]="{'disable-button':(isSelected.size <= 1 && deviceStatusReport !== 'generating') || (reportDownloadType === 'full' && deviceStatusReport === 'generating')}"
          [disabled]="(isSelected.size <= 1 && deviceStatusReport !== 'generating') || (reportDownloadType === 'full' && deviceStatusReport === 'generating')"
          (click)='generateSelectedReports()' class="btn btn-outline-primary btn-lg left_icon_btn gtmDevicesDownloadSelcReports">
          <img *ngIf="(deviceStatusReport !== 'generating') || !reportDownloadType || (reportDownloadType === 'full' && deviceStatusReport === 'generating')"
            [ngClass]="(isSelected.size <= 1 && deviceStatusReport !== 'generating') || !reportDownloadType || (reportDownloadType === 'full' && deviceStatusReport === 'generating') ?  'generate_package_icon_disabled':'generate_package_icon'"
            alt="generate selected reports">
          <span i18n="@@active-device-report.generate-selected-reports"
            *ngIf="(deviceStatusReport !== 'generating') || !reportDownloadType || (reportDownloadType === 'full' && deviceStatusReport === 'generating')">Generate Selected Reports</span>
        </button>
      </ng-container>
      <button type="button" class="btn btn-outline-primary btn-lg left_icon_btn gtmDevicesDownloadSelcReports"
        *ngIf="((deviceStatusReport === 'generated' || deviceStatusReport === 'generating') && reportDownloadType === 'multi' && isSelected.size >= 1 && isGenerateSelectedClicked)">
        <img *ngIf="deviceStatusReport === 'generated' && reportDownloadType === 'multi'" class="download-select-btn"
          alt="download selected reports">
        <span *ngIf="deviceStatusReport === 'generated' && reportDownloadType === 'multi'"
          i18n="@@active-device-report.data-header.download-selected-reports" (click)="downloadSelectedReports()">Download Selected Reports</span>
        <span *ngIf="deviceStatusReport === 'generating' && reportDownloadType === 'multi'"
          class="spinner-border text-primary"></span>
        <span i18n="@@active-device-report.report-being-generated" *ngIf="deviceStatusReport === 'generating' && reportDownloadType === 'multi'">Report is being generated</span>
      </button>
      <span *ngIf="userRole!=='storeUser'" [ngbPopover]="downloadMultipleReports" class="infoIcon"
        triggers="mouseenter:mouseleave">
        <span class="round-info-icon"></span>
      </span>
      <div class="main-generate" id="mainGenerate">
        <div class="generate-full" id="generateFull">
          <button class="btn btn-primary btn-lg left_icon_btn" *ngIf="deviceStatusReport === 'generated' && reportDownloadType === 'full'">
            <img class="generate_icon_white" alt="regenerate">
            <span i18n="@@active-device-report.generate-full-report" (click)='generateFullReports()'>Generate Full Report</span>
          </button>
          <button class="btn btn-primary btn-lg left_icon_btn gtmDevicesDownloadFullReport" placement="top" [ngbTooltip]="deviceStatusReport === 'generated' && reportDownloadType === 'full' ? downloadFullReportTooltip :''">
            <img *ngIf="!deviceStatusReport  || (reportDownloadType === 'multi') || !reportDownloadType"
              class="generate_icon_white" alt="Generate Full report">
            <span *ngIf="deviceStatusReport === 'generating' && reportDownloadType === 'full'"
              class="spinner-border text-light"></span>
            <img *ngIf="deviceStatusReport === 'generated' && reportDownloadType === 'full'" class="downloadbtn"
              alt="download full report" (click)="downloadIndividualFullReport('','downloadFull')">
            <span i18n="@@active-device-report.generate-full-report" *ngIf="!deviceStatusReport  || (reportDownloadType === 'multi') || !reportDownloadType"
              (click)='generateFullReports()'>Generate Full Report</span>
            <span i18n="@@active-device-report.report-being-generated" *ngIf="deviceStatusReport === 'generating' && reportDownloadType === 'full'">Report is being
              generated</span>
          </button>
          <div [ngbPopover]="downloadFullReport" triggers="mouseenter:mouseleave" [placement]="changePlacement == true ? 'top-left' : 'top-right'">
            <span class="round-info-icon"></span>
          </div>
        </div>
        <div *ngIf="deviceStatusReport === 'generated' && reportDownloadType === 'full'" class="last-generated" id="lastGenerated">
          <span i18n="@@active-device-report.last-generated-on">Last generated on {{ deviceLastGenerated | dateFormat:'shortDateFormat' }}</span>
        </div>
      </div>
    </div>
  </div>
  </div>

  <!-- Search button -->
  <div class="search_group" *ngIf="userRole!='storeUser'" id="searchGroup">
    <div class="input" id="input">
      <input type="search" #searchValue class="form-control input" [(ngModel)]="searchData"
      (keyup.enter)="searchReportOnEnter(searchData)" placeholder={{searchPlaceHolderText}} maxlength="75"
      (ngModelChange)="clearReportSearch(searchData)" />
    </div>
    <button (click)='searchActiveDeviceReport(searchData)' type="button" class="btn btn-primary search_btn gtmDevicesReportSearch">
      <img src="../../../../assets/images/search_icon.svg" alt="search" />
    </button>
  </div>
  <hr *ngIf="userRole!='storeUser'">

  <!-- Table data -->
  <div *ngIf="userRole!='storeUser' && displayActiveuser?.length" id="deviceReportTableDiv">
    <div class="table-responsive" id="tableResponsive">
      <table id="deviceReportTable" class="table table-borderless" aria-describedby="devicesTable">
        <thead>
          <tr>
            <th scope="col">
              <div class="text-center" id="textCenter">
                <!-- IIT2-1478 -->
                <input type="checkbox" [disabled]="!validData || deviceStatusReport === 'generating'"
                  [checked]='isMasterSel || isAllSelectedFlag'
                  (change)="isAllSelectedEnabeled($event.target.checked)" id="selectAllReports" />
                <!-- IIT2-1478 end  -->
              </div>
            </th>
            <th scope="col" *ngIf="userRole!='intelAdmin'">
              <div class="table_headings" id="tableHeadingsStoreName">
                <span i18n="@@active-device-report.table-data.store-name">Store Name</span>
                <span class="chevron_expand" (click)="sortActiveDevice('storename')"></span>
              </div>
            </th>
            <th scope="col" *ngIf="userRole!='regionalHQ' && userRole!='retailHQUser'  && userRole!='deviceExecutive'">
              <div class="table_headings" id="tableHeadingsHQName">
                <span i18n="@@active-device-report.table-data.retailHq-name" class="pb-1">Retail HQ Name</span>
                <span class="chevron_expand" (click)="sortActiveDevice('retailername')"></span>
              </div>
            </th>
            <th scope="col" *ngIf="userRole!='regionalHQ' && userRole!='retailHQUser'  && userRole!='deviceExecutive'">
              <div class="table_headings" id="storeCount">
                <span i18n="@@active-device-report.label.store-count" class="pb-1">Store Count</span>
                <span class="chevron_expand" (click)="sortActiveDevice('storecount')"></span>
              </div>
            </th>
            <th scope="col">
              <div class="table_headings" id="activeDeviceCount">
                <span i18n="@@active-device-report.table-data.active-device-count">Active Device Count</span>
                <span class="info-button" [ngbPopover]="activeDevices" triggers="mouseenter:mouseleave">
                  <span class="round-info-icon"></span>
                </span>
                <span class="chevron_expand" (click)="sortActiveDevice('storedevicecount')"></span>
              </div>
            </th>
            <th scope="col">
              <div class="table_headings" id="generatedBy">
                <span i18n="@@active-device-report.generated-by">Generated By</span>
                <span *ngIf="userRole!='intelAdmin'" class="info-button" [ngbPopover]="activeDevices" triggers="mouseenter:mouseleave">
                  <span class="round-info-icon"></span>
                </span>
                <span class="chevron_expand" (click)="sortActiveDevice('generatedby')"></span>
              </div>
            </th>
            <th scope="col">
              <div class="table_headings" id="lastGenerated">
                <span i18n="@@active-device-report.last-generated">Last Generated</span>
                <span *ngIf="userRole!='intelAdmin'" class="info-button" [ngbPopover]="activeDevices" triggers="mouseenter:mouseleave">
                  <span class="round-info-icon"></span>
                </span>
                <span class="chevron_expand" (click)="sortActiveDevice('lastgenerated')"></span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Row 1 -->
          <tr *ngFor='let data of displayActiveuser' class="row_hover">
            <td class="text-center"><input type="checkbox"
                [disabled]="!data.storeDeviceCount || deviceStatusReport === 'generating'"
                [checked]="isSelected.has(data?.retailerId) || isSelected.has(data?.storeId)"
                (change)='getSelectedReport(data)' /></td>
            <td *ngIf="userRole!='intelAdmin'">{{data?.storeName}}</td>
            <td *ngIf="userRole!='retailHQUser' && userRole!='deviceExecutive'" [ngClass]="userRole ==='regionalHQ' ? 'data-visibility':''">{{data?.retailerName}}</td>
            <td *ngIf="userRole!='retailHQUser' && userRole!='deviceExecutive'" [ngClass]="userRole ==='regionalHQ' ? 'data-visibility':''">{{data?.storeCount}}</td>
            <td>{{data.storeDeviceCount}}</td>
            <td>{{data?.storeId === globConst.NO_STORE_ID ? data?.lastGeneratedByNameNoStore : data?.lastGeneratedByName}}</td>
            <td>{{data?.storeId === globConst.NO_STORE_ID ? (data?.lastGeneratedTimeNoStore | dateFormat: "shortDateFormat") : data?.lastGeneratedTime ? (data?.lastGeneratedTime | dateFormat: "shortDateFormat"):'' }}</td>
            <td
              [ngClass]="checkGenerateStatus(data)"
              (click)='generateSelectedReport(data)'><em class="generate_package_icon"></em><span
                class="generate-icon-label" [innerHTML]="generate"></span></td>
            <td [ngClass]="checkgeneratingStatus(data)"><em
                class="spinner-border text-primary"></em><span [innerHTML]="generating"></span></td>
            <td
              [ngClass]="checkDownloadStatus(data)"
              (click)="downloadIndividualFullReport(data,'individual')">
              <em class="download_icon"></em><span class="download-icon-label" [innerHTML]="download"></span>
            </td>
          </tr>
        </tbody>
      </table>
      <hr *ngIf="displayActiveuser?.length > 0 && userRole!='storeUser'">
    </div>
  </div>
  <div class="text-center" *ngIf="!displayActiveuser?.length && userRole!='storeUser'" id="textCenter">
    <span *ngIf='!isLoading && isReportDataEmpty; else loading' i18n="@@active-users.expand.no-records-found">No Records Found</span>
    <ng-template #loading>
      <div class="text-center">{{globConst.LOADING}}</div>
    </ng-template>
  </div>
  <!-- Generate status pop-up-->
  <div *ngIf="isSelectGenerate" class="device-popup-outside" (click)="ClickedOut($event)" id="devicePopupOutSide">
    <div class="modal-dialog modal-dialog-centered" id="generateModalDialog">
      <div class="modal-dialog modal-dialog-centered" role="document" id="generateModalCentered">
        <div class="modal-backdrop show" id="modalBackdropShow"></div>
        <div class="modal" id="generatePopup">
          <div class="modal-dialog" id="generatePopupModalDialog">
            <div class="modal-content language_style" id="languageStyleModal">
              <div class="modal-body pb-0" id="modalBody">
                <div class="d-flex align-items-center mb-4" id="modalFlex">
                  <div id="reportWillBeEmailed"><span i18n="@@active-device-report.the-report-will-be-mailed">This report will be emailed to you and can be downloaded from here after generation.</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Pagination -->
  <div class="data_footer position-relative" id="dataFooterPagination" *ngIf="userRole!='storeUser' && displayActiveuser?.length">
    <div class="d-flex flex-column align-items-center" id="dataFooterFlex">
      <nav aria-label="device reports pagination">
        <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize"
                    [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
                    (pageChange)="onTableDataChange($event)">
                </ngb-pagination>
      </nav>
      <div class=" results mt-2" id="dataFooterResults">
        <span i18n="@@active-device-report.page-count">Showing <strong>{{ showFrom }} - {{ showTo }}</strong> of
          <strong>{{ paginationCount }} Retail HQs</strong></span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="openFullReportPopup" id="openFullReportModal">
  <div class="modal-dialog modal-dialog-centered" id="openFullReportModalDialog">
    <div class="modal-dialog modal-dialog-centered" role="document" id="openFullReportDocument">
      <div class="modal-backdrop show" id="modalBackDropShow"></div>
      <div class="modal profileSwitchPopUp" id="profileSwitchPopup">
        <div class="modal-dialog" id="profileSwitchModalDialog">
          <div class="modal-content regional_modal_content" id="regionalModalContent">
            <div class="close" data-dismiss="modal" (click)="closeDownloadPopup()" id="closeModal">
              <img class="modal-close-icon" alt="close" />
            </div>
            <div class="modal-body" id="profileSwitchModalBody">
              <div class="regional_card" id="regionalCard">
                <h2><span i18n="@@active-device-report.desc-trying-to-download">You are trying to download a report generated on {{generatedTimeStamp | dateFormat:'shortDateFormat'}}</span></h2>
                <div class="card_desc" id="cardDesc">
                  <span i18n="@@active-device-report.desc-click-to-generate">Click on generate to generate a fresh report or click on yes to download previously generated report.</span>
                </div>
              </div>
            </div>
            <div class="modal-footer card-footer" id="cardFooter">
              <button type="button" class="btn btn-outline-primary" (click)="regenerateFullReport()">
                <span>{{btnTextGenerate}}</span>
              </button>
              <button type="button" class="btn btn-primary btn-yes" (click)="downloadOldReports()">
                <span>{{btnTextYes}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true" (getStatus)='isLoading = $event'>
</iposcen-spinner-overlay>
<iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false" (getStatus)='isLoading = $event'>
</iposcen-spinner-overlay>